import { GoodsClassifierItemsPluginSettings } from "./GoodsClassifierItemsPluginSettings";

export const GoodsClassifierPluginSettings: IPluginSettings = {
    name: "Группы аналогов",
    mnemocode: "goods_classifier_plugin",
    permission: "GoodsClassifier",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "idGlobal",
            visibility: false,
            width: 200,
        },
        {
            order: 1,
            propertyName: "name",
            propertyType: "string",
            displayName: "Группа аналогов",
            visibility: true,
            width: 200,
        },
        {
            order: 2,
            propertyName: "code",
            propertyType: "string",
            displayName: "Источник",
            visibility: true,
            width: 200,
        },
        {
            order: 3,
            propertyName: "deleted",
            propertyType: "boolean",
            displayName: "Удалено",
            visibility: true,
            width: 200,
        },
        {
            order: 4,
            propertyName: "dateDeleted",
            propertyType: "datetime",
            displayName: "Дата удаления",
            visibility: true,
            width: 200,
        },
        {
            order: 5,
            propertyName: "dateModified",
            propertyType: "datetime",
            displayName: "Дата изменения",
            visibility: true,
            width: 200,
        }
    ],
    detailsPlugins: [
        GoodsClassifierItemsPluginSettings
    ]
}